export default "__VITE_ASSET__aa04ae5c__"